import { Palette } from 'theme/types'

export const defaultColors = {
  primary: {
    light: '#819CA9',
    main: '#546E7A',
    dark: '#29434E',
    contrastText: '#FFFFFF',
  },
  secondary: {
    light: '#90EF60',
    main: '#5bbc2e',
    dark: '#1e8b00',
    contrastText: '#FFFFFF',
  },
}

export function createPalette(): Partial<Palette> {
  const extra = {
    extra: {
      positive: '#21BA45',
      negative: '#DB2828',
      neutral: '#AEAEAE',
      warning: '#AEAEAE',
      info: '#AEAEAE',
    },
  }

  const mergedColors = { ...extra, ...defaultColors }
  return mergedColors
}
